import UserAdmin from "./UserAdmin";

export default UserAdmin;
